import React, { useEffect, useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination } from "swiper";

import User from "../../../../views/console/TypeA/Pages/User";

// Swiper 모듈 사용 설정
SwiperCore.use([Pagination]);

function UserList(props) {
  const { consoleCfg, setSessionMgrInfoModal } = props;

  // 모바일 여부 확인 (768px 미만)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // 모바일 세로모드 — TypeAStyle.js의 @media (max-width: 767px) and (orientation: portrait)와 동일 조건
  const computeIsMobilePortrait = () =>
    typeof window !== "undefined" &&
    window.innerWidth <= 767 &&
    window.innerHeight >= window.innerWidth;
  const [isMobilePortrait, setIsMobilePortrait] = useState(computeIsMobilePortrait);

  // 화면 크기/방향 변경 감지
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      setIsMobilePortrait(computeIsMobilePortrait());
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  // managerList 갯수
  const managerCount = consoleCfg?.managerList?.length || 0;

  // pagination 표시 여부 (5개 이상일 때만 표시하고, 모바일에서는 절대 표시 안함)
  const shouldShowPagination = managerCount >= 5 && !isMobile;

  // PC에서 슬라이드 설정
  const getPcSlidesPerView = () => {
    if (managerCount <= 0) return 1;
    return managerCount === 1 ? 1 :
           managerCount === 2 ? 2 :
           managerCount === 3 ? 3 : 4;
  };

  // 컨테이너 클래스 결정 — 모바일 세로모드에서만 m_slide_con 추가 (CSS의 모바일 전용 디자인 활성화)
  const baseClass = managerCount <= 1
    ? "slide_con slide_con_1"
    : managerCount <= 4
      ? "slide_con_flex"
      : "slide_con";
  const containerClass = isMobilePortrait ? `${baseClass} m_slide_con` : baseClass;

  // 모든 케이스를 하나의 Swiper로 처리
  return (
    <div className={containerClass}>
      <Swiper
        observer={true}
        observeParents={true}
        pagination={shouldShowPagination ? { clickable: true } : false}
        breakpoints={{
          0: { // 모바일
            slidesPerView: 1.5,
            slidesPerGroup: 1,
            spaceBetween: 30,
            allowTouchMove: true,
          },
          768: { // PC
            slidesPerView: getPcSlidesPerView(),
            spaceBetween: 30,
            allowTouchMove: managerCount > 4,
          },
        }}
        style={{
          paddingBottom: shouldShowPagination ? '30px' : '0px',
          // 1개 이하거나 2~4개일 때 Swiper 컨트롤 숨김
          ...(managerCount <= 4 && {
            '.swiper-wrapper': {
              display: managerCount <= 4 ? 'flex' : 'block',
              flexWrap: managerCount <= 4 ? 'wrap' : 'nowrap',
              justifyContent: managerCount <= 4 ? 'flex-start' : 'normal'
            }
          })
        }}
      >
        {consoleCfg?.managerList?.map((item, i) => (
          <SwiperSlide 
            key={`manager_slide_${i}_${item.managerIdx || item.name || i}`}
            style={{
              width: managerCount <= 4 && window.innerWidth >= 768 
                ? `calc(${100 / (managerCount || 1)}% - 20px)` 
                : ''
            }}
          >
            <User item={item} setSessionMgrInfoModal={setSessionMgrInfoModal} eventIdx={consoleCfg?.eventIdx}/>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default UserList;